module.exports = __webpack_public_path__ + "static/media/pattern5.ee760afb.svg";